import { ActionReducer, ActionReducerMap, createFeatureSelector, createSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../environments/environment';
import * as fromSites from '../sites/store/reducers/sites.reducer';
import * as fromUsers from '../users/store/reducers/users.reducer';
import { RouterStateUrl } from '../shared/utils';
import * as fromRouter from '@ngrx/router-store';
import { RouterReducerState } from '@ngrx/router-store';

export interface State {
	sitesData: fromSites.SitesState;
	usersData: fromUsers.UsersState;
	router: fromRouter.RouterReducerState<RouterStateUrl>;
}

export const reducers: ActionReducerMap<State> = {
	sitesData: fromSites.reducer,
	usersData: fromUsers.reducer,
	router: fromRouter.routerReducer,
};

export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : [];

export const getSitesState = createFeatureSelector<State, fromSites.SitesState>('sitesData');
export const getUsersState = createFeatureSelector<State, fromUsers.UsersState>('usersData');
export const selectRouter = createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');

export const getSites = createSelector(getSitesState, fromSites.getSites);

export const getSitesError = createSelector(getSitesState, fromSites.getSitesError);

export const getLoading = createSelector(getSitesState, fromSites.getLoading);

export const getSite = createSelector(getSitesState, fromSites.getSite);

export const getSelectedSiteTopLevelName = createSelector(getSitesState, fromSites.getSelectedSiteTopLevelName);

export const getSiteError = createSelector(getSitesState, fromSites.getSiteError);

export const getLoaded = createSelector(getSitesState, fromSites.getLoaded);

export const getDrawerStatus = createSelector(getSitesState, fromSites.getDrawerStatus);

export const getHoveredBoundary = createSelector(getSitesState, fromSites.getHoveredBoundary);

export const getUsers = createSelector(getUsersState, fromUsers.getUsers);

export const getUsersLoading = createSelector(getUsersState, fromUsers.getUsersLoading);
